import React from "react";

const LogoLight = () => {
    return (
        <svg
            className="h-12 sm:h-14 md:h-16 duration-300"
            viewBox="0 0 163 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M128.086 8.35199V20.832C128.086 24.768 126.79 26.4 123.622 26.4C120.598 26.4 119.254 24.672 119.254 20.736V8.35199H111.862V23.424C111.862 29.328 115.222 32.976 120.694 32.976C123.574 32.976 126.55 31.632 128.038 29.664L128.518 32.352H135.478V8.35199H128.086Z"
                fill="white"
            />
            <path
                d="M136.225 43.872H143.617V29.952C145.009 31.776 148.081 33.024 151.393 33.024C158.545 33.024 162.673 27.552 162.673 19.968C162.673 12.24 158.017 7.58398 151.345 7.58398C147.937 7.58398 144.913 9.07199 143.569 11.28L143.185 8.35199H136.225V43.872ZM143.665 20.352C143.665 16.752 146.065 14.352 149.521 14.352C153.025 14.352 155.233 16.8 155.233 20.352C155.233 23.904 153.025 26.352 149.521 26.352C146.065 26.352 143.665 23.952 143.665 20.352Z"
                fill="white"
            />
            <path d="M9.856 48.352V0.0959778H0V48.352H9.856Z" fill="url(#paint0_linear_8_6)" />
            <path
                d="M11.042 32.288C11.042 42.4 18.466 49.12 28.706 49.12C38.882 49.12 46.306 42.4 46.306 32.288C46.306 22.176 38.882 15.392 28.706 15.392C18.466 15.392 11.042 22.176 11.042 32.288ZM20.962 32.224C20.962 27.424 24.098 24.224 28.706 24.224C33.25 24.224 36.386 27.424 36.386 32.224C36.386 37.088 33.25 40.288 28.706 40.288C24.098 40.288 20.962 37.088 20.962 32.224Z"
                fill="url(#paint1_linear_8_6)"
            />
            <path
                d="M45.812 32.288C45.812 42.4 53.236 49.12 63.476 49.12C73.652 49.12 81.076 42.4 81.076 32.288C81.076 22.176 73.652 15.392 63.476 15.392C53.236 15.392 45.812 22.176 45.812 32.288ZM55.732 32.224C55.732 27.424 58.868 24.224 63.476 24.224C68.02 24.224 71.156 27.424 71.156 32.224C71.156 37.088 68.02 40.288 63.476 40.288C58.868 40.288 55.732 37.088 55.732 32.224Z"
                fill="url(#paint2_linear_8_6)"
            />
            <path
                d="M92.166 48.352V40.352L95.942 36.384L103.11 48.352H114.502L102.854 29.024L114.886 16.352H102.534L92.166 27.872V0.0959778H82.31V48.352H92.166Z"
                fill="url(#paint3_linear_8_6)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_8_6"
                    x1="57.443"
                    y1="24.9794"
                    x2="57.443"
                    y2="49.12"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF657F" />
                    <stop offset="1" stopColor="#9F34FF" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_8_6"
                    x1="57.443"
                    y1="24.9794"
                    x2="57.443"
                    y2="49.12"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF657F" />
                    <stop offset="1" stopColor="#9F34FF" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_8_6"
                    x1="57.443"
                    y1="24.9794"
                    x2="57.443"
                    y2="49.12"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF657F" />
                    <stop offset="1" stopColor="#9F34FF" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_8_6"
                    x1="57.443"
                    y1="24.9794"
                    x2="57.443"
                    y2="49.12"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF657F" />
                    <stop offset="1" stopColor="#9F34FF" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default LogoLight;
